import React from 'react'
import { Button } from 'primereact/button';

type Props = {
  encodeOn: boolean;
  handleSubmitButton: () => void;
}

const EncodeDecodeButton = ({ encodeOn, handleSubmitButton }: Props) => {

  return (
    <div>
      {encodeOn ?
        <Button label="Compress" onClick={handleSubmitButton} />
        :
        <Button label="Decompress" onClick={handleSubmitButton} />
      }
    </div>
  )
}

export default EncodeDecodeButton